import { motion } from 'framer-motion';
import { useLanguage } from '../../i18n/LanguageContext';
import { appendTrackingParams } from '../../utils/utm';

const TONES = [
  { bg: 'bg-ev-butter', text: 'text-ev-ink' },
  { bg: 'bg-ev-ink', text: 'text-white' },
  { bg: 'bg-ev-cream', text: 'text-ev-ink' },
  { bg: 'bg-ev-coral', text: 'text-ev-ink' },
  { bg: 'bg-ev-mint', text: 'text-ev-ink' },
  { bg: 'bg-ev-rose', text: 'text-ev-ink' },
];

export default function Community() {
  const { t } = useLanguage();

  return (
    <section id="community" className="bg-ev-sage py-24 md:py-32 px-6 md:px-10" data-testid="community-section">
      <div className="max-w-[1500px] mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-display font-light text-ev-ink lowercase text-center mb-16 md:mb-20"
          style={{ fontSize: 'clamp(2rem, 5vw, 4rem)', letterSpacing: '-0.03em' }}>
          {t.com_h}
        </motion.h2>

        {/* Fixed 1/2/3-column grid: 6 testimonials → 6 rows mobile / 3 rows tablet / 2 rows desktop */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {t.com_items.map((item, i) => {
            const tone = TONES[i % TONES.length];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                className={`${tone.bg} rounded-[1.75rem] p-7 md:p-8 flex flex-col h-full transition-transform hover:scale-[1.02]`}
                data-testid={`community-card-${i}`}>
                <p className={`font-body text-sm md:text-[15px] ${tone.text} leading-relaxed mb-5 flex-1`}>
                  &ldquo;{item.quote}&rdquo;
                </p>
                <p className={`font-body text-xs ${tone.text} opacity-70 lowercase`}>{item.who}</p>
              </motion.div>
            );
          })}
        </div>

        <div className="mt-14 md:mt-20 flex justify-center">
          <a
            href={appendTrackingParams(t.hero_cta_url)}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-3 bg-ev-lime hover:bg-ev-lime-dim text-ev-ink font-body font-medium text-sm rounded-full transition-colors lowercase"
            data-testid="community-cta">
            {t.com_cta}
          </a>
        </div>
      </div>
    </section>
  );
}
